import type React from 'react'
import { cn } from '@/frontend/utils'

export function Caption({ className, ...props }: React.ComponentPropsWithoutRef<'p'>) {
  return (
    <p {...props} className={cn('font-normal text-contentPrimary text-xs leading-4', className)} />
  )
}
